import React from 'react';

interface Props {
  label: string;
  shortcut: string;
}

export const RichTextToolbarTooltip: React.FC<Props> = ({
  label,
  shortcut,
}) => {
  return (
    <span className="slate__toolbar__tooltip" aria-hidden="true">
      <span className="slate__toolbar__tooltip__label">{label}</span>
      <span className="slate__toolbar__tooltip__shortcut">{shortcut}</span>
    </span>
  );
};
